import { connect } from 'react-redux';

import { replace } from '@talend/router-bridge';

import { CadReduxAction, CustomAttributeDefinition } from '../../CAD.types';
import { canCreateCAD } from '../../cache/identity.cache';
import {
	goToCADListAction,
	sendCADDefinitionCreation,
} from '../../service/CADForm/CADForm.actions';
import { getCADFormLoading } from '../../service/CADForm/CADForm.selectors';
import { CADAdd as Component } from './CADAdd.component';

export function redirectToForbidden(): object {
	return replace('/403', null, { type: 'REDIRECT_TO_FORBIDDEN' }) as CadReduxAction;
}

const mapState = (store: any) => {
	return {
		hasEntitlement: canCreateCAD(),
		loading: getCADFormLoading(store),
	};
};

const mapDispatch = (dispatch: Function) => {
	return {
		// eslint-disable-next-line @typescript-eslint/no-unsafe-return
		goToForbiddenPage: (): void => dispatch(redirectToForbidden()),
		onSubmit: (value: CustomAttributeDefinition) => {
			dispatch(sendCADDefinitionCreation(value));
		},
		// eslint-disable-next-line @typescript-eslint/no-unsafe-return
		onCancel: () => dispatch(goToCADListAction),
	};
};

export const CADAdd = connect(mapState, mapDispatch)(Component);
